import type { PayloadWrite } from "src/api/client-api/csrStrategy/Pillars/useUpsertCsrPillar";
import type { LeverValueColor } from "src/utils/csrStrategyValueColor";
import { defaultCsrPillarIconKey, getCsrPillarIconKey } from "src/utils/csrStrategyPillarIcons";
import { hasRichContent } from "src/utils/richText";

export type CsrIndicatorForm = {
    rowIndex: number;

    "@id": string | undefined;
    position?: number | null;
    name: string;
    leverShortName?: string | null;
    leverFullName?: string | null;
    indicatorLabel?: string | null;
    valueColor?: LeverValueColor | null;
    richContent?: string | null;
    unitCode: string;
    currentValue: string;
    shortTermTarget: string;
    longTermTarget: string;
};

export type CsrPillarForm = {
    id: string | undefined;
    position?: number | null;
    name: string;
    themes: number[];
    icon: string;
    indicators: CsrIndicatorForm[];
};

export const normalizeRichContentForWrite = (value?: string | null): string | null => {
    return hasRichContent(value) ? (value ?? null) : null;
};

export const formToCsrPillarWrite = (form: CsrPillarForm, stategyIRI: IRI): PayloadWrite => {
    const payload: PayloadWrite = {
        position: form.position,
        name: form.name.trim(),
        icon: form.icon ? getCsrPillarIconKey(form.icon) : defaultCsrPillarIconKey,
        strategy: stategyIRI,
        indicators: form.indicators.map((indicator) => {
            const { rowIndex: _rowIndex, ...indicatorPayload } = indicator;
            const indicatorLabel = indicator.indicatorLabel?.trim() ?? "";
            const leverShortName = indicator.leverShortName?.trim() ?? "";
            const legacyName = indicator.name.trim();
            const indicatorName = [indicatorLabel, leverShortName, legacyName].find(Boolean) ?? "";

            return {
                ...indicatorPayload,
                name: indicatorName,
                leverShortName,
                leverFullName: indicator.leverFullName?.trim() || null,
                indicatorLabel,
                unitCode: indicator.unitCode.trim(),
                richContent: normalizeRichContentForWrite(indicator.richContent),
            };
        }),
    };

    if (form.id !== undefined) {
        payload.id = form.id;
    }

    return payload;
};
